import { ConfigType } from '../utils/requestAPI';

type GetAllClientAssociatedPrinter = {
  page?: number;
  limit?: number;
  search?: string;
};
type AssociatePrinterWithClient = {
  printerId?: string[];
};
const printerApi = {
  getAllPrinter: (params?: GetAllClientAssociatedPrinter): ConfigType => {
    return {
      url: '/printers',
      method: 'get',
      params,
      config: { store: { action: 'set', key: 'printers.data' } },
    };
  },
  getPrinterJobById: (jobId: string): ConfigType => {
    return {
      url: `/printer-jobs/${jobId}`,
      method: 'get',
      config: { store: { action: 'set', key: 'singleClient.data' } },
    };
  },
  getAllClientAssociatedPrinter: (
    params: GetAllClientAssociatedPrinter
  ): ConfigType => {
    return {
      url: '/printers/client-associate-printers',
      method: 'get',
      params,
      config: { store: { action: 'set', key: 'printersList.data' } },
    };
  },
  associatePrinterWithClient: (
    data: AssociatePrinterWithClient
  ): ConfigType => {
    return {
      url: '/printers/associate-printer',
      method: 'post',
      data,
    };
  },

  getAllPrinterJobs: (params: { printerId: string }): ConfigType => {
    return {
      url: '/printer-jobs',
      method: 'get',
      params,
    };
  },

  getAllPrinterClient: (): ConfigType => {
    return {
      url: '/printer-jobs/printer-clients',
      method: 'get',
      config: { store: { action: 'set', key: 'PrinterClientList.data' } },
    };
  },

  getPrinterClientDetailById: (clientId: string): ConfigType => {
    return {
      url: `/printer-jobs/client/${clientId}`,
      method: 'get',
      config: { store: { action: 'set', key: 'singleClient.data' } },
    };
  },
  postPrinterJob: (data: any): ConfigType => {
    return {
      url: '/printer-jobs',
      method: 'post',
      data,
    };
  },
  updatePrinterJobStatus: (id: string, data: any): ConfigType => {
    return {
      url: `/printer-jobs/${id}/status`,
      method: 'patch',
      data,
    };
  },
};

export default printerApi;
